import React, { useState, useEffect } from "react";
import { Layers, ShoppingCart, DollarSign, Clock3 } from "lucide-react";

const Overview = ({ leathers, orders, colors }) => {
    const [now, setNow] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);
    const cardStyle = { backgroundColor: colors.bgCard, border: `1px solid ${colors.borderColor}`, borderRadius: '20px' };
    const iconBoxStyle = (bgColor, color) => ({ width: '50px', height: '50px', backgroundColor: bgColor, color: color, borderRadius: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center' });

    // Tính tổng giá trị kho da
    const totalInventoryValue = leathers.reduce((sum, item) => sum + (Number(item.price) || 0), 0);

    return (
        <div>
            <div className="mb-4">
                <h3 className="fw-bold mb-1" style={{ color: colors.textMain, letterSpacing: '0.5px' }}>Bespoke Overview</h3>
                <span style={{ color: colors.textMuted, fontSize: '14px' }}>System metrics and general statistics</span>
            </div>

            <div className="row g-4 mb-4" style={{ alignItems: 'stretch' }}>
                <div className="col-md-3 d-flex">
                    <div className="p-4 shadow-sm d-flex align-items-center hover-card w-100" style={cardStyle}>
                        <div className="me-4 flex-shrink-0" style={iconBoxStyle('rgba(197, 160, 117, 0.15)', '#C5A075')}><Layers size={24} /></div>
                        <div>
                            <p className="text-muted small fw-bold mb-1">LEATHER TYPES</p>
                            <h3 className="fw-bold m-0" style={{ color: colors.textMain }}>{leathers.length}</h3>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 d-flex">
                    <div className="p-4 shadow-sm d-flex align-items-center hover-card w-100" style={cardStyle}>
                        <div className="me-4 flex-shrink-0" style={iconBoxStyle('rgba(34, 197, 94, 0.15)', '#22c55e')}><ShoppingCart size={24} /></div>
                        <div>
                            <p className="text-muted small fw-bold mb-1">TOTAL ORDERS</p>
                            <h3 className="fw-bold m-0" style={{ color: colors.textMain }}>{orders.length}</h3>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 d-flex">
                    <div className="p-4 shadow-sm d-flex align-items-center hover-card w-100" style={cardStyle}>
                        <div className="me-4 flex-shrink-0" style={iconBoxStyle('rgba(59, 130, 246, 0.15)', '#3b82f6')}><DollarSign size={24} /></div>
                        <div>
                            <p className="text-muted small fw-bold mb-1">INVENTORY VALUE</p>
                            <h4 className="fw-bold m-0 mt-1" style={{ color: colors.textMain }}>${totalInventoryValue.toFixed(2)}</h4>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 d-flex">
                    <div className="p-4 shadow-sm d-flex align-items-center hover-card w-100" style={cardStyle}>
                        <div className="me-4 flex-shrink-0" style={iconBoxStyle('rgba(245, 158, 11, 0.15)', '#f59e0b')}><Clock3 size={24} /></div>
                        <div>
                            <p className="text-muted small fw-bold mb-1">CURRENT TIME</p>
                            <h5 className="fw-bold m-0" style={{ color: colors.textMain, fontFamily: 'monospace', letterSpacing: '1px' }}>
                                {now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                            </h5>
                            <p className="text-muted m-0" style={{ fontSize: '0.75rem' }}>
                                {now.toLocaleDateString('en-US', { dateStyle: 'medium' })}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Overview;